import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DlistDto, GetDlist_Request, GetDlist_Response } from '../../../models/ortak.dtos';
import { DataCoreService } from '../../../services/data-core.service';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable()
export class VGenBirimService {
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
    public birimTuru: string;
    public checkData: boolean;
    public isActive!: boolean;
    public isYetkili!: boolean;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}

     setParams(birimTuru: string, checkData: boolean, isActive: boolean, isYetkili: boolean,isReadOnly:boolean, isBindCheck:boolean){
      this.birimTuru = birimTuru;
      this.checkData = checkData;
      this.isActive = isActive;
      this.isYetkili = isYetkili;
      this.isReadOnly = isReadOnly;
      this.isBindCheck = isBindCheck;
     }

     getDlist(formName:string):any {
      const request=new GetDlist_Request({
        dListCode:formName
      })
       this._httpClient.post<GetDlist_Response>(`${env.lookupService}/System/GetDList`, request).pipe(
        tap(response => {
          this._gridControlsList.next(response.dListMetadata)
        }),
        catchError(err => throwError(err)),
        finalize(() => {})
      ).subscribe();
    }

  getData(code: number,control:any, birimTuru:string, baseEntity: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);
    } 
    else{
    if(this.isYetkili){
      tableName = baseEntity + "?BirimTuru=YS"
    }
    else{
      if(birimTuru)  tableName = baseEntity + "?BirimTuru=" + birimTuru
      else tableName = baseEntity + "?BirimTuru=Y"
    }
    dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);
    if(this.isActive && !isSetData) filterArr.push(['AktifEh', '=', 'E']);
    }

    if(code) filterArr.push(['Kod', '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }

  getCheckData(code: number) {
    const dataSource = this.dataCoreService.getOData('IkaBirimKatsayi');
    dataSource.select(['Kod']);
    const filterArr = [];
    filterArr.push(['Kod', '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
}
}
